import { css } from "@emotion/react"
import Color from "color"
import { useRef } from "react"
import { getComputedStylePropertyValue } from "source/shared/getComputedStylePropertyValue"

type FrequencyTypeButtonProps = {
  active: boolean
  children: React.ReactNode
  onClick?: () => void
}

export function FrequencyTypeButton({
  active,
  children,
  onClick,
}: FrequencyTypeButtonProps) {
  const ref = useRef<HTMLLabelElement>(null)

  function handleChange() {
    onClick?.()

    requestAnimationFrame(() => {
      ref.current?.scrollIntoView({
        behavior: "smooth",
        inline: "center",
      })
    })
  }

  return (
    <label
      className="p-r d-ib p-0"
      css={css`
        cursor: pointer;
      `}
      ref={ref}
    >
      <input
        type="radio"
        name="frequency-type"
        checked={active}
        onChange={handleChange}
        className="visually-hidden"
      />
      <span
        className="btn text-btn w-100%@md"
        css={[styles.button, styles.buttonFocus, active && styles.buttonActive]}
      >
        {children}
      </span>
    </label>
  )
}

const translucentBrandColor = Color(
  getComputedStylePropertyValue("--color-brand"),
)
  .hsl()
  .lightness(96)
  .string()

const styles = {
  button: css`
    border: 1px solid var(--color-tint5);
    border-radius: 1.5rem;
    padding-inline: 1rem;
  `,
  buttonActive: css`
    background: ${translucentBrandColor};
    border-width: 2px;
    border-color: var(--color-brand);
    color: var(--color-brand);
    font-weight: 500;
  `,
  buttonFocus: css`
    input[type="radio"]:focus-visible + & {
      box-shadow:
        inset 0 0 0 1px var(--color-tint10),
        inset 0 0 0 3px var(--color-topaz);
    }
  `,
}
